
import router from '@/router'
import store from '@/store'
import appConst from '@/utils/consts'
import FileCfg from '../../../static/config/fileCfg'

window.cx = require('../../../static/lib/cx')

window.router = router
window.store = store


cx.http = require('../../lib/Http').default
cx.http.setUrlCrypt(true)

window.appConst = appConst
window.FileCfg = FileCfg

export default {
}



// WEBPACK FOOTER //
// ./src/utils/impLibs/ImpCx.js